export const AlarmSeverities = [
    { key: 0, value: 'Information' },
    { key: 1, value: 'Warning' },
    { key: 2, value: 'Critical' }
];